/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { atomToPromise } from '../../utilities/atomToPromise';
import { getAssociatedRecordsUtils } from '../../utilities/associatedRecordsUtils';
import { useEffect, useState } from 'react';
// @ts-expect-error untyped
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ObjectTypeWrapper = styled.span.withConfig({
  displayName: "DisplayValueAssociation__ObjectTypeWrapper",
  componentId: "eka6h4-0"
})(["font-weight:normal !important;"]);
const DisplayValueAssociation = ({
  data,
  filterFamily,
  getFamilyValueResolver,
  operator
}) => {
  const {
    getCustomObjectReferenceResolver,
    getObjectDefinition,
    getObjectTypeIdFromPropertySuffix
  } = getAssociatedRecordsUtils(data, filterFamily);
  const [objectName, setObjectName] = useState('');
  const associatedObjectTypeId = getObjectTypeIdFromPropertySuffix(operator.propertySuffix);
  const objectDefinition = associatedObjectTypeId ? getObjectDefinition(associatedObjectTypeId) : undefined;
  const resolver = getCustomObjectReferenceResolver(getFamilyValueResolver(operator), associatedObjectTypeId);
  useEffect(() => {
    if (resolver && resolver.byId && operator.value) {
      atomToPromise(resolver.byId(operator.value)).then(result => {
        setObjectName(result.label);
      });
    }
  }, [operator.value, resolver]);
  const singularForm = objectDefinition ? objectDefinition.singularForm : undefined;
  if (singularForm && objectName) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "customerDataFilters.DisplayValueAssociation.label",
      options: {
        objectName,
        singularObjectType: /*#__PURE__*/_jsx(ObjectTypeWrapper, {
          children: singularForm
        })
      }
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: operator.value
  });
};
DisplayValueAssociation.propTypes = {
  data: ImmutablePropTypes.map.isRequired,
  filterFamily: PropTypes.string.isRequired,
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired
};
export default DisplayValueAssociation;